import $ from "jquery";
import Splide, { LOOP } from '@splidejs/splide';

import Sly from "sly-scrolling/src/sly";

class Sliders {

	constructor() {
		this.dom();
		this.initAwardsSliders();
		this.initBlogPostSliders();
		this.initBlogPostImageSliders();
		this.initQuotesSliders();
		this.initHomeSliders();
		this.initMaterialiSliders();
		this.initTimelineSliders();
		this.initSingleSliders();
		this.initCustomCardSliders();
		this.initProductsSliders();
		this.initSingleProductSliders();

		this.initProductGallerySlider();
	}

	dom() {
		this.$sliders = $('.splide');
		this.$awardsSliders = this.$sliders.filter('.slider-awards');
		this.$blogPostSliders = this.$sliders.filter('.slider-blog-post');
		this.$blogPostImageSliders = this.$sliders.filter('.slider-blog-post-image');
		this.$quotesSliders = this.$sliders.filter('.slider-quotes');
		this.$progressSlider = this.$sliders.filter('.slider-home');
		this.$materialiSliders = this.$sliders.filter('.slider-materiali');
		this.$timelineSliders = this.$sliders.filter('.slider-timeline');
		this.$singleSliders = this.$sliders.filter('.slider-single');
		this.$customCardSliders = this.$sliders.filter('.slider-custom-card');
		this.$productsSliders = this.$sliders.filter('.products-slider');
		this.$singleProductSliders = this.$sliders.filter('.slider-single-product');

		this.$productGallerySlider = this.$sliders.filter('.product-gallery-slider');
	}

	initProductGallerySlider() {
		this.$productGallerySlider.find('.woocommerce-product-gallery__image').addClass('splide__slide ');

		this.$productGallerySlider.each((i) => {
			const $slider = this.$productGallerySlider.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					drag:false,
					autoWidth: false,
					perMove: 1,
					perPage: 1,
					arrows: true,
					pagination: false,
					start: 0,
					padding: 0,
					gap: 0
				});

				$slider.on('click', function(e) {
					$slider.find('.splide__track').sly('reload');
				});

				// $(window).on('resize', function(e) {
				// 	$slider.find('.splide__track').sly('reload');
				// });

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});

	}

	initHomeSliders() {
		this.$progressSlider.each((i) => {
			const $slider = this.$progressSlider.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					autoWidth: false,
					arrows: false,
					pagination: false,
					perPage: 1,
					start: 0,
					padding: 0
				});

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}
		});
	}

	initAwardsSliders() {
		this.$awardsSliders.each((i) => {
			const $slider = this.$awardsSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					autoWidth: true,
					perMove: 1,
					arrows: false,
					pagination: false,
					start: 0,
					padding: 0,
					gap: 0

				})

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});
	}

	initBlogPostSliders() {
		this.$blogPostSliders.each((i) => {
			const $slider = this.$blogPostSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					destroy: true,
					arrows: false,
					pagination: false,
					perPage: 3,
					breakpoints: {
						1200: {
							destroy: false,
							arrows: true,
							perPage: 2
						},
						768: {
							perPage: 1,
						}
					}
				}).mount();

				$slider.data('splide', splide);
			}
		})
	}

	initBlogPostImageSliders() {
		this.$blogPostImageSliders.each((i) => {
			const $slider = this.$blogPostImageSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					type: "loop",
					destroy: true,
					arrows: false,
					pagination: false,
					perPage: 2,
					breakpoints: {
						1024: {
							destroy: false,
							arrows: true,
							perPage: 1
						},
					}
				}).mount();

				$slider.data('splide', splide);
			}
		});
	}

	initQuotesSliders() {
		this.$quotesSliders.each((i) => {
			const $slider = this.$quotesSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					type: "loop",
					arrows: true,
					pagination: false,
					perPage: 2,
					breakpoints: {
						1024: {
							perPage: 1
						}
					}
				}).mount();

				$slider.data('splide', splide);
			}
		})
	}

	initProductsSliders() {
		this.$productsSliders.each((i) => {
			const $slider = this.$productsSliders.eq(i);
			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					arrows: true,
					pagination: false,
					start: 0,
					padding: 0,
					gap: 24,
					destroy: false,
					perPage: 3,
					breakpoints: {
						1200: {
							perPage: 2
						},
						768: {
							perPage: 1,
						}
					}
				}).mount();

				$slider.data('splide', splide);
			}
		});
	}

	initMaterialiSliders() {
		this.$materialiSliders.each((i) => {
			const $slider = this.$materialiSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					autoWidth: true,
					perMove: 1,
					arrows: false,
					pagination: false,
					start: 0,
					padding: 0,
					gap: 0

				})

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});
	}

	initTimelineSliders() {
		this.$timelineSliders.each((i) => {
			const $slider = this.$timelineSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					//type: 'loop',
					autoWidth: false,
					arrows: true,
					pagination: false,
					start: 0,
					perMove: 1,
					padding: 0,
					perPage: 3,
					breakpoints: {
						1024: {
							perPage: 2,
						},
						768: {
							perPage: 1
						}
					}

				})

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});
	}

	initSingleSliders() {
		this.$singleSliders.each((i) => {
			const $slider = this.$singleSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					type: "loop",
					arrows: true,
					pagination: false,
					start: 0,
					padding: 0,
					gap: 24,

				}).mount();

				$slider.data('splide', splide);
			}

		});
	}

	initCustomCardSliders() {
		this.$customCardSliders.each((i) => {
			const $slider = this.$customCardSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					autoWidth: false,
					arrows: true,
					pagination: false,
					perPage: 3,
					breakpoints: {
						1024: {
							perPage: 2
						},
						768: {
							perPage: 1
						}
					}

				})

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});
	}

	initSingleProductSliders() {
		this.$singleProductSliders.each((i) => {
			const $slider = this.$singleProductSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					autoWidth: false,
					arrows: true,
					pagination: false,
					perPage: 3,
					perMove: 1,
					breakpoints: {
						1024: {
							perPage: 2
						},
						768: {
							perPage: 1
						}
					}
				})

				this.initSliderScrollbar($slider, splide);

				this.initWidthHandle($slider, splide);

				splide.mount();

				$slider.data('splide', splide);
			}

		});
	}

	initWidthHandle($slider, splide) {
		const $bar = $slider.find('.scrollbar .handle');
		const end = $slider.find('.splide__slide').length;
		var rate = 1;

		if (isFinite(100 / end)) {
			rate = 100 / end;
		}

		if ($bar) {
			$bar.attr("style", "width:" + rate + '%' + ';');
		}
	}

	initSliderScrollbar($slider, splide, params = []) {
		var throttled = false;

		const $scrollbar = $slider.find('.scrollbar');
		
		if($scrollbar.length > 0) {
			splide.on('mounted', function () {
				$slider.find('.splide__track').sly({
					horizontal: 1,
					itemNav: 'basic',
					smart: 1,
					mouseDragging: 1,
					touchDragging: 1,
					scrollBar: $slider.find('.scrollbar'),
					scrollBy: (params['scrollBy'] != null) ? params['scrollBy'] : 0,
					speed: 1000,
					dragHandle: 1,
					clickBar: 1,
					releaseSwing: true,
					scrollHijack: 500,

					// Buttons
					prevPage: $slider.find('.splide__arrow--prev'),
					nextPage: $slider.find('.splide__arrow--next')
				})

				$(window).on('resize', function(e) {
					$slider.find('.splide__track').sly('reload');
					throttled = true;
					setTimeout(() => {
						throttled = false;
					}, 350);
				});
			})
		}
	}
}

export default Sliders;